import { ReactNode } from 'react'
import { PatientForActDtoIds } from '@toktokdoctech/tokapi-client'

export enum PlannedExpertiseStepperStep {
    PATIENT = 0,
    CONSENT = 1,
    REQUESTER = 2,
    REQUIRED = 3,
    WORKFLOW = 4,
}

export type RequesterData = {
    requesterId: string
    requiredExpertLabel: string
    profession: string
    speciality: string
}

export type RequiredData = {
    requiredExpertId: string
    requiredExpertLabel: string
    profession?: string
    speciality?: string
    isHcsEmployee: boolean
}

export type PatientData = {
    id: string
    fullName: string
    birthdate: string
    age: number
    sex: string
}

export type SelectedPatientType = {
    patientId: string
    patientLibelle: string
    patientData?: PatientForActDtoIds
} | null

export type SelectedWorkflowType = {
    id: string
    name: string
} | null

export type PlannedExpertiseEditorProps = {
    expertiseDetail: {
        patientId: string
        patientLibelle: string
        requiredExpertId: string
        requiredExpertLibelle: string
        appointmentDate: null | Date | string
    }
    isNewExpertise?: boolean
    onSave: () => void
}

export type PlannedExpertiseStepperRecap = {
    patientFullName?: string
    patientBirthdate?: string
    patientSex?: string
    patientId?: string
    requesterId?: string
    requiredExpertId?: string
    requiredExpertLabel?: string
    workflowId?: string
    workflowLabel?: string
}

export type PlannedExpertiseStepperProps = {
    onComplete?: () => void
    onAbandon?: () => void
    onRecapChange?: (recap: PlannedExpertiseStepperRecap | null) => void
}

export type PatientStepDefaultValues = {
    patientId: string
    patientLibelle: string
    patientData?: PatientForActDtoIds
}

export type PatientStepProps = {
    onDataChange?: (data: { patientId: string; patientLibelle: string; patientData?: PatientForActDtoIds }) => void
    onSelectAndContinue?: () => void
    defaultValues?: PatientStepDefaultValues
}

export type ConsentStepProps = {
    patient: any
    consentGiven: boolean | null
    onConsentChange: (value: boolean) => void
}

export type PlannedExpertiseRequesterHelpDialogProps = {
    isOpen: boolean
    onClose: () => void
}

export type PlannedExpertiseAddRequesterDialogProps = {
    isOpen: boolean
    onClose: () => void
    onConfirm: () => void
}

export type PlannedExpertiseFillAddressDialogProps = {
    open: boolean
    onCancel: () => void
    onProceed: () => void
}

export type PlannedExpertiseAbandonDialogProps = {
    isOpen: boolean
    onClose: () => void
    onConfirm: () => void
    transmissionId?: string
    mode: 'stepper' | 'workflow'
}

export type WorkflowStepProps = {
    onDataChange?: (data: { id: string; name: string; workflowId: string; workflowLabel: string }) => void
}

export type RequiredStepProp = {
    onDataChange?: (data: {
        requiredExpertId: string
        requiredExpertLabel: string
        profession?: string
        speciality?: string
        isHcsEmployee: boolean
    }) => void
}

export type RequesterStepProps = {
    patient: any
    consentGiven: boolean | null
    onConsentChange: (value: boolean) => void
    onDataChange?: (data: {
        requesterId: string
        requiredExpertLabel: string
        profession: string
        speciality: string
    }) => void
}

type SelectedRequiredExpert = {
    profession: string
    requiredExpertId: string
    requiredExpertLabel: string
    isHcsEmployee: boolean
    speciality: string
}

export type InitiationPreviewStepProps = {
    selectedPatient: {
        patientId: string
        patientLibelle: string
        patientData?: PatientForActDtoIds
    } | null
    selectedRequester: any | null
    selectedRequired: SelectedRequiredExpert | null
    selectedWorkflow: { id: string; name: string } | null
    isConsentValid?: boolean
    onEditPatient: () => void
    onEditRequester: () => void
    onEditRequired: () => void
    onEditWorkflow: () => void
    onInit: () => void
}
